import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Button extends Component {
  shouldExecute = true;

  static propTypes = {
    showProgress: PropTypes.bool,
  };

  static defaultProps = {
    showProgress: false,
  };

  state = {
    saving: false,
  };
  componentWillUnmount() {
    this.shouldExecute = false;
  }
  handleClick(e) {
    this.buttonDOM.blur();
    const { onClick, showProgress } = this.props;

    if (showProgress) {
      this.setState(state => ({
        ...state,
        saving: true,
      }));
    }

    return Promise.resolve(onClick(e)).finally(() => this.removeProgress());
  }

  removeProgress = () => {
    // Prevent setting state on unmounted component
    if (!this.shouldExecute) return;
    this.setState(state => ({
      ...state,
      saving: false,
    }));
  };

  render() {
    const { children, btnClassName, onClick, showProgress, disabled, ...rest } = this.props;
    const { saving } = this.state;

    const buttonDisabled = disabled || (showProgress && saving);
    const showSpinner = showProgress && saving;

    return (
      <button
        type="button"
        ref={buttonDOM => {
          this.buttonDOM = buttonDOM;
        }}
        onClick={e => !buttonDisabled && this.handleClick(e)}
        className={classnames('btn btn-default', btnClassName)}
        disabled={buttonDisabled}
        {...rest}
      >
        {showSpinner && <i className="fa fa-spinner fa-spin margin5R" />}
        {children}
      </button>
    );
  }
}
